export enum RecurringType {
    None = '',
    Daily = 'daily',
    Weekly = 'weekly',
    Monthly = 'monthly'
}